import React from 'react';
import type { WidgetRow } from 'App/components/hooks/integrations/externalIntegrationTypes';
import { Flex, Text } from '@upsales/components';
import './UiWidgetEmptyRow.scss';

interface UiWidgetEmptyRowProps {
	row: WidgetRow['settings'];
	widgetExternalId?: string;
	widgetType?: string;
	dataSource?: any;
	widgetSettings?: any;
}

const UiWidgetEmptyRow: React.FC<UiWidgetEmptyRowProps> = ({ row, widgetExternalId }) => {
	return (
		<Flex className="UiWidgetEmptyRow" alignItems="center" justifyContent="center">
			{/* Intentionally left empty for spacing */}
			<Text className="UiWidgetEmptyRow__text">&nbsp;</Text>
		</Flex>
	);
};

export default UiWidgetEmptyRow;
